import React, { useState } from 'react';
import { Alert, Spin, Divider } from 'antd';
import { Row, Col, Input } from 'components/ui';
import {
  useFetchGmailAccounts,
  useGetGmailAccountDailyLimit,
} from 'query/gmail';
import GmailAccountListTable from './GmailAccountListTable';
import WatchGmailAccountsButton from './WatchGmailAccountsButton';
import AuthorizeGmailAccountButton from './AuthorizeGmailAccountButton';

const AuthorizeGmailAccount = () => {
  const [loading, setLoading] = useState(false);
  const { data, fetching: loadingAccounts } = useFetchGmailAccounts({
    mountOnUpdate: true,
    refetchInterval: 1000 * 60 * 5,
  });
  const {
    data: limitData,
    isLoading: limitLoading,
  } = useGetGmailAccountDailyLimit();
  const [error, setError] = useState();
  const [search, setSearch] = useState('');

  const handleSearchChange = e => setSearch(e.target.value);

  return (
    <Spin spinning={loading}>
      {error && <Alert message={error} type={'error'} />}
      <Row>
        <Col span={10}>
          <div style={{ display: 'flex' }}>
            <AuthorizeGmailAccountButton
              setError={setError}
              setLoading={setLoading}
            />
            <WatchGmailAccountsButton />
          </div>
        </Col>
      </Row>
      <Divider />
      <Spin spinning={loadingAccounts || limitLoading}>
        <div className="gmail-ch-panel">
          <div className="gmail-ch-search">
            <i className="material-icons md-24 gmail-ch-icon">search</i>
            <Input
              placeholder="Filter by name or email"
              style={{ border: '0' }}
              value={search}
              onChange={handleSearchChange}
            />
          </div>
          <GmailAccountListTable
            data={data}
            filtered={[{ id: 'all', value: search }]}
            limitData={limitData}
          />
        </div>
      </Spin>
    </Spin>
  );
};

export default AuthorizeGmailAccount;
